module.exports = __webpack_public_path__ + "media/images/w_4-44eb28f9fc19bb672d6799cd2a5e2752.png";